/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as PrizeSettingsRouteImport } from './routes/prize-settings'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as BallotsRouteImport } from './routes/ballots'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersAddRouteImport } from './routes/users_.add'
import { Route as UsersUserIdRouteImport } from './routes/users_.$userId'
import { Route as ResultsAddRouteImport } from './routes/results_.add'
import { Route as ResultsResultIdRouteImport } from './routes/results_.$resultId'
import { Route as ResultsViewResultIdRouteImport } from './routes/results-view_.$resultId'
import { Route as ProfilesUserIdRouteImport } from './routes/profiles_.$userId'
import { Route as PrizeSettingsAddRouteImport } from './routes/prize-settings_.add'
import { Route as PrizeSettingsContestIdRouteImport } from './routes/prize-settings_.$contestId'
import { Route as CategoriesAddRouteImport } from './routes/categories_.add'
import { Route as CategoriesCategoryIdRouteImport } from './routes/categories_.$categoryId'
import { Route as BallotsAddRouteImport } from './routes/ballots_.add'
import { Route as BallotsBallotIdRouteImport } from './routes/ballots_.$ballotId'
import { Route as ArtworksAddRouteImport } from './routes/artworks_.add'
import { Route as ArtworksArtworkIdRouteImport } from './routes/artworks_.$artworkId'
import { Route as ArtworksPreviewArtworkIdRouteImport } from './routes/artworks-preview_.$artworkId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const PrizeSettingsRoute = PrizeSettingsRouteImport.update({
  id: '/prize-settings',
  path: '/prize-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const BallotsRoute = BallotsRouteImport.update({
  id: '/ballots',
  path: '/ballots',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersAddRoute = UsersAddRouteImport.update({
  id: '/users_/add',
  path: '/users/add',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users_/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsAddRoute = ResultsAddRouteImport.update({
  id: '/results_/add',
  path: '/results/add',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsResultIdRoute = ResultsResultIdRouteImport.update({
  id: '/results_/$resultId',
  path: '/results/$resultId',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsViewResultIdRoute = ResultsViewResultIdRouteImport.update({
  id: '/results-view_/$resultId',
  path: '/results-view/$resultId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesUserIdRoute = ProfilesUserIdRouteImport.update({
  id: '/profiles_/$userId',
  path: '/profiles/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const PrizeSettingsAddRoute = PrizeSettingsAddRouteImport.update({
  id: '/prize-settings_/add',
  path: '/prize-settings/add',
  getParentRoute: () => rootRouteImport,
} as any)
const PrizeSettingsContestIdRoute = PrizeSettingsContestIdRouteImport.update({
  id: '/prize-settings_/$contestId',
  path: '/prize-settings/$contestId',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesAddRoute = CategoriesAddRouteImport.update({
  id: '/categories_/add',
  path: '/categories/add',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesCategoryIdRoute = CategoriesCategoryIdRouteImport.update({
  id: '/categories_/$categoryId',
  path: '/categories/$categoryId',
  getParentRoute: () => rootRouteImport,
} as any)
const BallotsAddRoute = BallotsAddRouteImport.update({
  id: '/ballots_/add',
  path: '/ballots/add',
  getParentRoute: () => rootRouteImport,
} as any)
const BallotsBallotIdRoute = BallotsBallotIdRouteImport.update({
  id: '/ballots_/$ballotId',
  path: '/ballots/$ballotId',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtworksAddRoute = ArtworksAddRouteImport.update({
  id: '/artworks_/add',
  path: '/artworks/add',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtworksArtworkIdRoute = ArtworksArtworkIdRouteImport.update({
  id: '/artworks_/$artworkId',
  path: '/artworks/$artworkId',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtworksPreviewArtworkIdRoute =
  ArtworksPreviewArtworkIdRouteImport.update({
    id: '/artworks-preview_/$artworkId',
    path: '/artworks-preview/$artworkId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/ballots': typeof BallotsRoute
  '/categories': typeof CategoriesRoute
  '/login': typeof LoginRoute
  '/prize-settings': typeof PrizeSettingsRoute
  '/results': typeof ResultsRoute
  '/users': typeof UsersRoute
  '/artworks-preview/$artworkId': typeof ArtworksPreviewArtworkIdRoute
  '/artworks/$artworkId': typeof ArtworksArtworkIdRoute
  '/artworks/add': typeof ArtworksAddRoute
  '/ballots/$ballotId': typeof BallotsBallotIdRoute
  '/ballots/add': typeof BallotsAddRoute
  '/categories/$categoryId': typeof CategoriesCategoryIdRoute
  '/categories/add': typeof CategoriesAddRoute
  '/prize-settings/$contestId': typeof PrizeSettingsContestIdRoute
  '/prize-settings/add': typeof PrizeSettingsAddRoute
  '/profiles/$userId': typeof ProfilesUserIdRoute
  '/results-view/$resultId': typeof ResultsViewResultIdRoute
  '/results/$resultId': typeof ResultsResultIdRoute
  '/results/add': typeof ResultsAddRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/add': typeof UsersAddRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/ballots': typeof BallotsRoute
  '/categories': typeof CategoriesRoute
  '/login': typeof LoginRoute
  '/prize-settings': typeof PrizeSettingsRoute
  '/results': typeof ResultsRoute
  '/users': typeof UsersRoute
  '/artworks-preview/$artworkId': typeof ArtworksPreviewArtworkIdRoute
  '/artworks/$artworkId': typeof ArtworksArtworkIdRoute
  '/artworks/add': typeof ArtworksAddRoute
  '/ballots/$ballotId': typeof BallotsBallotIdRoute
  '/ballots/add': typeof BallotsAddRoute
  '/categories/$categoryId': typeof CategoriesCategoryIdRoute
  '/categories/add': typeof CategoriesAddRoute
  '/prize-settings/$contestId': typeof PrizeSettingsContestIdRoute
  '/prize-settings/add': typeof PrizeSettingsAddRoute
  '/profiles/$userId': typeof ProfilesUserIdRoute
  '/results-view/$resultId': typeof ResultsViewResultIdRoute
  '/results/$resultId': typeof ResultsResultIdRoute
  '/results/add': typeof ResultsAddRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/add': typeof UsersAddRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/ballots': typeof BallotsRoute
  '/categories': typeof CategoriesRoute
  '/login': typeof LoginRoute
  '/prize-settings': typeof PrizeSettingsRoute
  '/results': typeof ResultsRoute
  '/users': typeof UsersRoute
  '/artworks-preview_/$artworkId': typeof ArtworksPreviewArtworkIdRoute
  '/artworks_/$artworkId': typeof ArtworksArtworkIdRoute
  '/artworks_/add': typeof ArtworksAddRoute
  '/ballots_/$ballotId': typeof BallotsBallotIdRoute
  '/ballots_/add': typeof BallotsAddRoute
  '/categories_/$categoryId': typeof CategoriesCategoryIdRoute
  '/categories_/add': typeof CategoriesAddRoute
  '/prize-settings_/$contestId': typeof PrizeSettingsContestIdRoute
  '/prize-settings_/add': typeof PrizeSettingsAddRoute
  '/profiles_/$userId': typeof ProfilesUserIdRoute
  '/results-view_/$resultId': typeof ResultsViewResultIdRoute
  '/results_/$resultId': typeof ResultsResultIdRoute
  '/results_/add': typeof ResultsAddRoute
  '/users_/$userId': typeof UsersUserIdRoute
  '/users_/add': typeof UsersAddRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/ballots'
    | '/categories'
    | '/login'
    | '/prize-settings'
    | '/results'
    | '/users'
    | '/artworks-preview/$artworkId'
    | '/artworks/$artworkId'
    | '/artworks/add'
    | '/ballots/$ballotId'
    | '/ballots/add'
    | '/categories/$categoryId'
    | '/categories/add'
    | '/prize-settings/$contestId'
    | '/prize-settings/add'
    | '/profiles/$userId'
    | '/results-view/$resultId'
    | '/results/$resultId'
    | '/results/add'
    | '/users/$userId'
    | '/users/add'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/ballots'
    | '/categories'
    | '/login'
    | '/prize-settings'
    | '/results'
    | '/users'
    | '/artworks-preview/$artworkId'
    | '/artworks/$artworkId'
    | '/artworks/add'
    | '/ballots/$ballotId'
    | '/ballots/add'
    | '/categories/$categoryId'
    | '/categories/add'
    | '/prize-settings/$contestId'
    | '/prize-settings/add'
    | '/profiles/$userId'
    | '/results-view/$resultId'
    | '/results/$resultId'
    | '/results/add'
    | '/users/$userId'
    | '/users/add'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/ballots'
    | '/categories'
    | '/login'
    | '/prize-settings'
    | '/results'
    | '/users'
    | '/artworks-preview_/$artworkId'
    | '/artworks_/$artworkId'
    | '/artworks_/add'
    | '/ballots_/$ballotId'
    | '/ballots_/add'
    | '/categories_/$categoryId'
    | '/categories_/add'
    | '/prize-settings_/$contestId'
    | '/prize-settings_/add'
    | '/profiles_/$userId'
    | '/results-view_/$resultId'
    | '/results_/$resultId'
    | '/results_/add'
    | '/users_/$userId'
    | '/users_/add'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  BallotsRoute: typeof BallotsRoute
  CategoriesRoute: typeof CategoriesRoute
  LoginRoute: typeof LoginRoute
  PrizeSettingsRoute: typeof PrizeSettingsRoute
  ResultsRoute: typeof ResultsRoute
  UsersRoute: typeof UsersRoute
  ArtworksPreviewArtworkIdRoute: typeof ArtworksPreviewArtworkIdRoute
  ArtworksArtworkIdRoute: typeof ArtworksArtworkIdRoute
  ArtworksAddRoute: typeof ArtworksAddRoute
  BallotsBallotIdRoute: typeof BallotsBallotIdRoute
  BallotsAddRoute: typeof BallotsAddRoute
  CategoriesCategoryIdRoute: typeof CategoriesCategoryIdRoute
  CategoriesAddRoute: typeof CategoriesAddRoute
  PrizeSettingsContestIdRoute: typeof PrizeSettingsContestIdRoute
  PrizeSettingsAddRoute: typeof PrizeSettingsAddRoute
  ProfilesUserIdRoute: typeof ProfilesUserIdRoute
  ResultsViewResultIdRoute: typeof ResultsViewResultIdRoute
  ResultsResultIdRoute: typeof ResultsResultIdRoute
  ResultsAddRoute: typeof ResultsAddRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
  UsersAddRoute: typeof UsersAddRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prize-settings': {
      id: '/prize-settings'
      path: '/prize-settings'
      fullPath: '/prize-settings'
      preLoaderRoute: typeof PrizeSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ballots': {
      id: '/ballots'
      path: '/ballots'
      fullPath: '/ballots'
      preLoaderRoute: typeof BallotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users_/add': {
      id: '/users_/add'
      path: '/users/add'
      fullPath: '/users/add'
      preLoaderRoute: typeof UsersAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users_/$userId': {
      id: '/users_/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results_/add': {
      id: '/results_/add'
      path: '/results/add'
      fullPath: '/results/add'
      preLoaderRoute: typeof ResultsAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results_/$resultId': {
      id: '/results_/$resultId'
      path: '/results/$resultId'
      fullPath: '/results/$resultId'
      preLoaderRoute: typeof ResultsResultIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results-view_/$resultId': {
      id: '/results-view_/$resultId'
      path: '/results-view/$resultId'
      fullPath: '/results-view/$resultId'
      preLoaderRoute: typeof ResultsViewResultIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles_/$userId': {
      id: '/profiles_/$userId'
      path: '/profiles/$userId'
      fullPath: '/profiles/$userId'
      preLoaderRoute: typeof ProfilesUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prize-settings_/add': {
      id: '/prize-settings_/add'
      path: '/prize-settings/add'
      fullPath: '/prize-settings/add'
      preLoaderRoute: typeof PrizeSettingsAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prize-settings_/$contestId': {
      id: '/prize-settings_/$contestId'
      path: '/prize-settings/$contestId'
      fullPath: '/prize-settings/$contestId'
      preLoaderRoute: typeof PrizeSettingsContestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories_/add': {
      id: '/categories_/add'
      path: '/categories/add'
      fullPath: '/categories/add'
      preLoaderRoute: typeof CategoriesAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories_/$categoryId': {
      id: '/categories_/$categoryId'
      path: '/categories/$categoryId'
      fullPath: '/categories/$categoryId'
      preLoaderRoute: typeof CategoriesCategoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ballots_/add': {
      id: '/ballots_/add'
      path: '/ballots/add'
      fullPath: '/ballots/add'
      preLoaderRoute: typeof BallotsAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ballots_/$ballotId': {
      id: '/ballots_/$ballotId'
      path: '/ballots/$ballotId'
      fullPath: '/ballots/$ballotId'
      preLoaderRoute: typeof BallotsBallotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artworks_/add': {
      id: '/artworks_/add'
      path: '/artworks/add'
      fullPath: '/artworks/add'
      preLoaderRoute: typeof ArtworksAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artworks_/$artworkId': {
      id: '/artworks_/$artworkId'
      path: '/artworks/$artworkId'
      fullPath: '/artworks/$artworkId'
      preLoaderRoute: typeof ArtworksArtworkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artworks-preview_/$artworkId': {
      id: '/artworks-preview_/$artworkId'
      path: '/artworks-preview/$artworkId'
      fullPath: '/artworks-preview/$artworkId'
      preLoaderRoute: typeof ArtworksPreviewArtworkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  BallotsRoute: BallotsRoute,
  CategoriesRoute: CategoriesRoute,
  LoginRoute: LoginRoute,
  PrizeSettingsRoute: PrizeSettingsRoute,
  ResultsRoute: ResultsRoute,
  UsersRoute: UsersRoute,
  ArtworksPreviewArtworkIdRoute: ArtworksPreviewArtworkIdRoute,
  ArtworksArtworkIdRoute: ArtworksArtworkIdRoute,
  ArtworksAddRoute: ArtworksAddRoute,
  BallotsBallotIdRoute: BallotsBallotIdRoute,
  BallotsAddRoute: BallotsAddRoute,
  CategoriesCategoryIdRoute: CategoriesCategoryIdRoute,
  CategoriesAddRoute: CategoriesAddRoute,
  PrizeSettingsContestIdRoute: PrizeSettingsContestIdRoute,
  PrizeSettingsAddRoute: PrizeSettingsAddRoute,
  ProfilesUserIdRoute: ProfilesUserIdRoute,
  ResultsViewResultIdRoute: ResultsViewResultIdRoute,
  ResultsResultIdRoute: ResultsResultIdRoute,
  ResultsAddRoute: ResultsAddRoute,
  UsersUserIdRoute: UsersUserIdRoute,
  UsersAddRoute: UsersAddRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
